export function getMockAuth() {  
    const isMockEnabled = process.env.REACT_APP_USE_MOCK_AUTH === 'true'
    const mockToken = process.env.REACT_APP_MOCK_TOKEN
            
    return { isMockEnabled, mockToken }; 
};
